import { render, staticRenderFns } from "./ResultadoAnalise.vue?vue&type=template&id=2a511a09&"
import script from "./ResultadoAnalise.vue?vue&type=script&lang=js&"
export * from "./ResultadoAnalise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports